import React from 'react';
import Barcode from 'react-barcode';
import { Asset } from '../types';
import { formatDate } from '../utils/formatters';

interface AssetLabelProps {
    asset: Asset;
    activeTab: '49x30' | '40x30' | '35x25';
    companyName?: string;
    dateFormat?: string;
}

export const AssetLabel: React.FC<AssetLabelProps> = ({ asset, activeTab, companyName, dateFormat = 'DD/MM/YYYY' }) => {
    // Dimensions mapping
    const dimensions = {
        '49x30': { width: '49mm', height: '30mm', p: '2mm' },
        '40x30': { width: '40mm', height: '30mm', p: '2mm' },
        '35x25': { width: '35mm', height: '25mm', p: '1mm' }
    };

    const style = dimensions[activeTab];

    // 49x30: Barcode + Description + Property Of
    if (activeTab === '49x30') {
        return (
            <div style={{ width: style.width, height: style.height, padding: style.p }} className="bg-white border border-slate-200 flex flex-col items-center justify-between overflow-hidden relative">
                <div className="text-center w-full leading-none">
                    <p className="text-[8px] font-bold text-slate-900 truncate w-full px-1 mb-0.5">
                        {asset.description?.substring(0, 25) || 'ASSET'}
                    </p>
                </div>
                <div className="flex-1 flex items-center justify-center w-full overflow-hidden">
                    {asset.barcode ? (
                        <Barcode value={asset.barcode} width={1} height={20} fontSize={8} displayValue={true} margin={0} />
                    ) : (
                        <span className="text-[8px] text-slate-300">No Barcode</span>
                    )}
                </div>
                {companyName && (
                    <div className="w-full text-center mt-0.5 leading-none">
                        <span className="text-[5px] sm:text-[6px] font-semibold text-slate-800 tracking-wider">PROPERTY OF - {companyName.toUpperCase()}</span>
                    </div>
                )}
            </div>
        );
    }

    // 40x30 & 35x25: Barcode Only (mostly)
    return (
        <div style={{ width: style.width, height: style.height, padding: style.p }} className="bg-white border border-slate-200 flex flex-col items-center justify-center overflow-hidden">
            <div className="w-full h-full flex items-center justify-center">
                {asset.barcode ? (
                    <Barcode
                        value={asset.barcode}
                        width={activeTab === '35x25' ? 1 : 1.2}
                        height={activeTab === '35x25' ? 20 : 25}
                        fontSize={9}
                        displayValue={true}
                        margin={0}
                    />
                ) : (
                    <span className="text-[8px] text-slate-300">No Barcode</span>
                )}
            </div>
        </div>
    );
};
